/**
 * Citação de jurisprudência aguardando inserção numa peça.
 *
 * A busca de jurisprudência guarda a citação aqui e abre o editor da peça escolhida;
 * o editor consome a citação depois de carregar o documento e a insere no final.
 */

const STORAGE_KEY = 'ap_pending_citation';
const MAX_AGE_MS = 10 * 60 * 1000;

export interface PendingCitation {
  documentId: string;
  citation: string;
  desfecho?: string;
  tribunal: string;
  numeroProcesso: string;
  createdAt: number;
}

export function savePendingCitation(c: Omit<PendingCitation, 'createdAt'>): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...c, createdAt: Date.now() }));
  } catch {
    // sessionStorage indisponível (modo privado restrito): o editor simplesmente não recebe a citação
  }
}

/** Devolve e remove a citação pendente para este documento, se houver e for recente. */
export function takePendingCitation(documentId: string): PendingCitation | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const c = JSON.parse(raw) as PendingCitation;
    if (c.documentId !== documentId) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    return Date.now() - c.createdAt <= MAX_AGE_MS ? c : null;
  } catch {
    return null;
  }
}

const escapeHtml = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/**
 * Trecho no formato de petição: citação recuada e um marcador [PREENCHER] para o advogado
 * colar o trecho da decisão (o DataJud não fornece ementa nem inteiro teor).
 */
export function citationToHtml(c: PendingCitation): string {
  const desfecho = c.desfecho ? ` Desfecho: ${escapeHtml(c.desfecho)}.` : '';
  return (
    `<p style="text-align: justify;">Nesse sentido, confira-se o seguinte precedente do ${escapeHtml(c.tribunal)}:</p>` +
    `<p style="text-align: justify; margin-left: 4cm; font-size: 11pt;">[PREENCHER: trecho da decisão]</p>` +
    `<p style="text-align: justify; margin-left: 4cm; font-size: 11pt;">(${escapeHtml(c.citation)}${desfecho})</p>`
  );
}
